<template>
    <div class="product-options">
        <h4 class="mb-2">Optional Extras</h4>

        <b-row no-gutters>
            <b-col cols="3" class="d-flex flex-column">
                <b-nav vertical class="product-options-nav">
                    <b-nav-item v-for="extra in product.extras" v-bind:class="{'active': activeExtra && extra.extra === activeExtra.extra}" v-on:click="setExtra(extra)">
                        {{ extra.extra }}
                    </b-nav-item>
                </b-nav>

                <b-button class="mt-auto btn-block" v-b-modal.optionalExtraModal>
                    <icon name="plus"></icon> Add Optional Extra
                </b-button>
            </b-col>

            <b-col cols="9">
                <div class="panel product-options-panel">
                    <div v-if="activeExtra">
                        <product-extra :extra="activeExtra" :product="product"></product-extra>
                    </div>

                    <div v-if="!activeExtra" class="select-extra">
                        <icon name="question"></icon>
                        Please select an optional extra
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-modal id="optionalExtraModal" ref="optionalExtraModal" @ok="okNewExtra" title="Add Optional Extra">
            <form @submit.stop.prevent="submitNewExtra">
                <b-form-select v-model="newExtra" :options="extraLabels"></b-form-select>
            </form>
        </b-modal>
    </div>
</template>

<script>
import ProductExtra from './ProductExtra.vue'

export default {
  name: 'productOptions',
  props: ['product', 'extras', 'countries'],
  components: {
    ProductExtra
  },
  data () {
    return {
      activeExtra: null,
      newExtra: null
    }
  },
  methods: {
    okNewExtra (e) {
      e.cancel()
      if (this.newExtra) {
        this.submitNewExtra()
      } else {
        alert('Please select an option')
      }
    },
    submitNewExtra () {
      // create a new extra object
      if (!this.product.extras) {
        this.product.extras = []
      }
      let extra = {
        extra: this.newExtra,
        costPrice: null,
        maxQty: 1,
        availableTo: 'all',
        pricing: {},
        pricingInSSP: {}
      }
      this.newExtra = null
      this.activeExtra = extra
      this.product.extras.push(extra)
      this.$refs.optionalExtraModal.hide()
    },
    setExtra (extra) {
      this.activeExtra = extra
    }
  },
  computed: {
    extraLabels () {
      return this.extras.map((val) => {
        return {
          value: val.label,
          text: val.label
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ProductOptions.vue